export default class SEOAccordion {
	constructor(el, index) {
		this.element = el
		this.index = index

		this.content = this.element.querySelector('.c-SEOAccordion__content')
		this.button = this.element.querySelector('button')

		this.onClick = this.onClick.bind(this)
	}

	init() {
		this.button.addEventListener('click', this.onClick)
		this.content.hidden = true
	}

	onClick() {
		const expanded = this.button.getAttribute('aria-expanded') === 'true'

		this.button.setAttribute('aria-expanded', String(!expanded))
		this.content.hidden = expanded
	}

	unmount() {
		this.button.removeEventListener('click', this.onClick)
	}
}
